export default "__VITE_ASSET__5CzdC422__"